import request from '@/utils/request'

const group_name = 'ntocc-tms-api'
const api_name = 'estimate'

export default {
  // 查询列表
  query(params) {
    return request({
      url: `/${group_name}/${api_name}/queryorder`,
      method: 'post',
      params: params,
    })
  },
  
  top(params) {
    return request({
      url: `/${group_name}/${api_name}/getcount`,
      method: 'post',
      params: params,
      // params: {},
      // headers: {
      //   'Content-Type': 'multipart/form-data'
      // }
    })
  },
  
  storehouse(params) {
    return request(
      {
        url: `/${group_name}/${api_name}/init`,
        method: 'post',
        params: params
      }
    )
  },  

}
